
const $meta = {
    Home: {
      title: "灭除蟑螂_消灭老鼠_防治白蚁_专业上门除虫公司-Byepest虫虫拜拜官网",
      description: "Byepest虫虫拜拜原隶属于世界500强德国拜耳，是其孵化的家庭虫害防治服务品牌。2022年该事业部以全新品牌Envu安蔚优独立运营。Envu安蔚优根植于拜耳百年的历史经验，将继续保持在环境科学行业的全球领先地位。",
      keyword: '上门除虫,除白蚁,除老鼠,灭蟑螂,灭跳蚤,防治白蚁,灭老鼠,灭鼠公司'
    },
    // About: {
    //   title: "关于我们_家庭虫害防治领先者-拜耳虫虫拜拜官网",
    //   description: "拜耳自有服务团队，严格质量把控。针对现场量身定制方案，严选用药，保障家人和宠物的健康安全。",
    //   keyword: '害虫防治,家庭虫害防治领先者,虫害解决方案,上门除虫服务'
    // },
    // baiyikancha: {
    //   title: "防治白蚁_白蚁灭治_专业灭除白蚁公司-拜耳虫虫拜拜官网",
    //   description: "白蚁会严重危害房屋建筑且入侵不易察觉。拜耳虫虫拜拜提供专业的白蚁勘查和灭治服务，为您竖起保护建筑的“金钟罩”。",
    //   keyword: '白蚁灭治,白蚁勘察,白蚁危害,白蚁公司,白蚁灭治服务公司'
    // },
    // baiyiyufang: {
    //   title: "白蚁预防_专业防治白蚁_白蚁防治公司-拜耳虫虫拜拜官网",
    //   description: "白蚁危害严重，但在问题发生前，拜耳虫虫拜拜可以对房屋进行全面的预防处理，有效阻绝白蚁入侵，保障建筑和家具安全。",
    //   keyword: '白蚁预防,上门白蚁预防公司,装修预防白蚁,除白蚁公司,除虫公司'
    // },
    // laoshu: {
    //   title: "灭除老鼠公司_消灭老鼠_专业上门杀除老鼠-拜耳虫虫拜拜官网",
    //   description: "拜耳自有工程师团队，帮您识别隐蔽鼠迹，通过布控关键点快速捕捉老鼠，并找出建筑环境风险点，使用专业材料封堵，消除后续隐患。",
    //   keyword: '上门除老鼠,捉老鼠,除虫公司'
    // },
    // mayi: {
    //   title: "灭除蚂蚁_蚂蚁防治_专业上门消灭蚂蚁公司-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜使用拜耳官方正品药剂，强效吸引蚂蚁；专业工程师展开勘查，快速找出屋内蚂蚁活动点和滋生源，连锁灭杀，立竿见影。",
    //   keyword: '除蚂蚁,除白蚁公司,上门除虫,蚂蚁防治方法'
    // },
    // profession: {
    //   title: "专业灭虫公司_上门虫害检测_家庭除虫服务-拜耳虫虫拜拜官网",
    //   description: "拜耳虫虫拜拜自有工程师将通过专业、全面、有针对性的勘察，帮您准确判断家中的虫害问题。",
    //   keyword: '专业虫害检测,除虫服务,家庭除虫服务,虫害防治专家,上门除虫,虫子识别'
    // },
    // prevention: {
    //   title: "虫害防治_专业灭虫公司_综合虫害预防服务-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜根据外围环境、房屋结构、湿度、卫生进行常见害虫找寻、滋生情况摸查，科学掌握居家环境的虫害抵抗力，通过多重手段快速灭杀已有常见害虫，消除潜藏在角落的健康隐患，建立持久有效的虫害防御屏障。",
    //   keyword: '虫害灭治,专业除虫公司,综合虫害预防服务'
    // },
    // tiaozao: {
    //   title: "灭除跳蚤_杀跳蚤_专业上门除跳蚤公司-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜采用拜耳科学喷洒方案，快速灭杀跳蚤成虫，疗程式治理，全面触达跳蚤藏匿点效果更加长久有效。",
    //   keyword: '灭除跳蚤,专业除跳蚤服务公司,上门除虫'
    // },
    // bieshu: {
    //   title: "专业除虫_安全无忧_健康管理-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜科学除虫专家，安全除虫，健康无忧。60+害虫定期巡检，科学方案部署全生态系统防治，管家式响应管理，持续保障环境健康。",
    //   keyword: '专业除虫,安全无忧,健康管理'
    // },
    // feichong: {
    //   title: "飞虫无忧_灭蚊子_别墅飞虫控制-拜耳虫虫拜拜官网",
    //   description: "拜耳虫虫拜拜飞虫包月服务，量身定制方案，周期性上门维护，帮您远离蚊子等飞虫侵扰。服务详情及价格请关注拜耳虫虫拜拜官网。",
    //   keyword: '室内外除飞虫,灭蚊子,蚊虫拜拜,夏季灭蚊,飞虫包月'
    // },
    // paidui: {
    //   title: "派对除虫_派对活动紧急控蚊-拜耳虫虫拜拜官网",
    //   description: "拜耳虫虫拜拜派对活动紧急控蚊服务，全空间无死角高效灭蚊，让您的活动告别蚊虫叮咬。服务详情及价格请关注拜耳虫虫拜拜官网。",
    //   keyword: '派对除虫,派对活动紧急控蚊服务,高效控蚊,驱蚊'
    // },
    // zhanglang: {
    //   title: "灭除蟑螂公司_蟑螂根除_专业上门消灭蟑螂-拜耳虫虫拜拜官网",
    //   description: "拜耳虫虫拜拜可以快速灭除蟑螂。自有工程师团队将根据现场环境，使用拜耳官方正品药剂对症下药，强效吸引，隔夜见效，效果持久。",
    //   keyword: '除蟑螂,上门除蟑螂,上门除虫,蟑螂胶饵'
    // },
    // commonpest: {
    //   title: "专业除蟑螂灭鼠_白蚁防治-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜官网为您提供专业除虫灭鼠服务，如除蟑螂、灭老鼠、灭蚂蚁、灭跳骚、白蚁防治等。更多除虫服务请关注虫虫拜拜官网。",
    //   keyword: '专业除蟑螂,灭鼠,白蚁防治,灭跳骚,灭蚂蚁'
    // },
    // termite: {
    //   title: "白蚁防治_灭白蚁_白蚁预防-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜官网为您提供专业除虫灭鼠服务，如白蚁灭治、防治、预防等。更多除虫服务请关注虫虫拜拜官网。",
    //   keyword: '白蚁防治,灭白蚁,白蚁预防'
    // },
    // villapest: {
    //   title: "别墅除虫_别墅除虫包年_别墅除虫包月-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜官网为您提供专业别墅除虫灭鼠服务，包年除虫服务、包月除虫服务、派对除虫服务等。更多除虫服务请关注虫虫拜拜官网。",
    //   keyword: '别墅除虫,别墅除虫包年,别墅除虫包月'
    // },
    // 虫害百科
    PestWiki: {
      title: "虫害百科_家庭虫害防治-Byepest虫虫拜拜官网",
      description: "欢迎查看虫虫拜拜为您精选编辑的虫害百科，快速了解常见害虫生活习性、危害和防治建议。",
      keyword: '虫害百科,害虫习性,害虫危害,害虫防治建议,常见害虫'
    },
    // 虫害百科详情
    '2': {
      title: "蟑螂_除蟑螂最有效的方法_家里有蟑螂怎么办-Byepest虫虫拜拜官网",
      description: "温暖潮湿、食物丰富和多缝隙，是蟑螂孳生的基本条件。我们的生活工作空间，不管是厨房还是卫生间，甚至是散落了食物碎屑的沙发都有可能成为蟑螂的入侵点。",
      keyword: '蟑螂,小强,德国小蠊,大蠊,蟑螂的危害'
    },
    '10': {
      title: "寄螨虫_怎样除螨虫_除螨喷雾真的可以去螨虫吗-Byepest虫虫拜拜官网",
      description: "寄螨总目包含所有蜱螨类生物，大多数是寄生生物，其中革螨、蜱对人类生活危害较大，会对人发起攻击，通过叮咬、吸血等方式致使人过敏、皮炎甚至严重疾病。",
      keyword: '寄螨,蜱虫,革螨,寄生性害虫,蜱虫的危害'
    },
    '11': {
      title: "衣鱼虫_消灭衣鱼虫的经验_衣鱼虫怎么消灭-Byepest虫虫拜拜官网",
      description: "衣鱼俗称书虫，是一种无翅昆虫，尾部有三根长毛（缨尾），常躲藏在黑暗处，滋生地通常比较潮湿，会啃食书籍、衣物、墙纸装潢等。",
      keyword: '衣鱼,书虫,衣鱼防治建议,消灭衣鱼虫的经验'
    },
    '12': {
      title: "厨卫飞虫_厨卫飞虫怎么处理_蛾蚋怎么消灭-Byepest虫虫拜拜官网",
      description: "常见的厨卫飞虫有蛾蚋、果蝇、蚤蝇、蕈蚊等。这些飞虫基本不咬人，但由于其滋生地通常为藏污纳垢之处，容易接触和携带环境中的细菌，给人带来滋扰危害。",
      keyword: '厨卫飞虫怎么处理,厨卫飞虫,蛾蚋,果蝇,蚤蝇,蕈蚊'
    },
    '13': {
      title: "织物害虫_衣服被虫蛀怎么办_衣物怎么防蛀虫-Byepest虫虫拜拜官网",
      description: "织物/地毯害虫以天然蛋白质（角蛋白）为食，任何动物来源的织物材料都可能成为它们破坏的对象，包括羊毛、棉花、丝绸、皮革和羽毛等，有些也会危害粮食谷物。",
      keyword: '家庭虫害防治,织物害虫,衣蛾,皮蠹'
    },
    '14': {
      title: "蛀木害虫_家具被虫蛀怎么办_家具怎么防蛀虫-Byepest虫虫拜拜官网",
      description: "蛀木害虫会对房屋木质结构和木家具等造成破坏，通常是被携带进入或从外部入侵室内，大多有趋光性，随着绿化建设不断提升，入侵室内的可能性也随之增高。",
      keyword: '家庭驱虫公司,蛀木害虫,粉蠹,窃蠹,天牛'
    },
    '15': {
      title: "叮蛰害虫_被蜜蜂蛰了怎么办_被黄蜂蛰了怎么处理-Byepest虫虫拜拜官网",
      description: "叮蛰害虫多为社会性昆虫，由蜂王、雄蜂、工蜂等组成。在感到自身或蜂群受到威胁时，会以叮蛰进行防卫。叮蛰害虫中，只有雌性才会叮蛰，有些叮蛰害虫毒性十分强。",
      keyword: '家庭虫害防治,叮蛰害虫,寄生蜂,蜜蜂,黄蜂'
    },
    '16': {
      title: "潮湿害虫_书虱怎么消灭_怎样防治跳虫-Byepest虫虫拜拜官网",
      description: "很多家庭楼层较低或家居没做好防潮处理，很容易出现墙体发霉、微菌滋生、虫害繁殖的情况，在这些区域常出现的害虫被统称为潮湿害虫。",
      keyword: '潮湿害虫,潮湿害虫怎么处理,书虱,米扁虫,薪甲,伪瓢虫'
    },
    '17': {
      title: "仓储害虫_米虫怎么防治_谷螟怎么清除-Byepest虫虫拜拜官网",
      description: "仓储害虫常见于谷物、麦子、脱水的水果和种子中，无论是家庭还是商用场所如食品工厂、仓库、餐厅等都可见到它们的身影，会对粮食储物造成污染和危害。",
      keyword: '仓储害虫,锯谷盗,米象,烟草甲,印度谷螟,仓储害虫防治方法'
    },
    '18': {
      title: "多足害虫_家里有马陆怎么消灭_鼠妇怎么彻底消灭-Byepest虫虫拜拜官网",
      description: "多足害虫多以腐殖质或小昆虫为食，常见于室外草地、土壤中，喜欢阴暗潮湿的环境，但有时也会因湿度、食物、植物携带等原因进入室内，造成危害。",
      keyword: '家庭虫害防治,多足害虫,千足虫,蜈蚣,蚰蜒,马陆'
    },
    '20': {
      title: "花园害虫_蜘蛛怎么消灭_鼻涕虫从哪里爬出来的-Byepest虫虫拜拜官网",
      description: "草坪、花园、绿化当中是各类甲虫、爬虫、飞虫等害虫聚集的热点区域，我们将其统称为花园害虫。偶尔它们会因觅食或在室内寻到合适的栖息地，或被灯光吸引入侵室内。",
      keyword: '驱害虫服务公司,花园害虫,蜘蛛,蛞蝓,蝽,隐翅虫'
    },
    '3': {
      title: "白蚁_白蚁防治方法_白蚁怎么消灭才干净-Byepest虫虫拜拜官网",
      description: "作为最古老的社会性昆虫之一，白蚁常被视为破坏力最大的害虫。白蚁群体中有明确“社会分工”，往往种族庞大，尤其是台湾乳白蚁，常有多个隐匿藏身处，处理难度较大。",
      keyword: '白蚁,灭白蚁服务公司,飞蚂蚁,台湾乳白蚁,散白蚁,白蚁的危害'
    },
    '4': {
      title: "老鼠_老鼠怎么消灭_家里有老鼠怎么办-Byepest虫虫拜拜官网",
      description: "老鼠是现存最原始的哺乳动物之一，生命力旺盛、数量繁多且迅速。凭借超强的适应能力和智商，老鼠几乎适应了各地的环境，这也给人类带来了源源不断的困扰和危害。",
      keyword: '老鼠,老鼠怎么消灭,耗子,小家鼠,褐家鼠,黄胸鼠'
    },
    '5': {
      title: "蚂蚁_蚂蚁防治方法_如何消灭蚂蚁-Byepest虫虫拜拜官网",
      description: "蚂蚁是常见社会性昆虫，依据形态、行为和社会分工可分为：雌蚁、雄蚁、工蚁和兵蚁。各品级各司其职。蚂蚁如果入侵室内，也会对人们的工作、生活带来危害和滋扰。",
      keyword: '蚂蚁,蚂蚁防治方法,小黄家蚁,红火蚁,弓背蚁,蚂蚁的危害'
    },
    '6': {
      title: "跳蚤_跳蚤怎么消灭_跳蚤怎么来的-Byepest虫虫拜拜官网",
      description: "跳蚤是一种小型、无翅、善跳跃的寄生性昆虫，通常寄生在哺乳类动物和鸟类身上，有锐利的刺吸式口器。跳蚤叮咬会产生瘙痒、过敏反应，还可能传播疾病。",
      keyword: '跳蚤怎么消灭,跳蚤,猫蚤,狗蚤,跳蚤的危害'
    },
    '7': {
      title: "苍蝇_怎么驱除苍蝇_苍蝇多怎样消灭-Byepest虫虫拜拜官网",
      description: "苍蝇多以腐败有机物为食，具有舐吮式口器，会污染食物，传播疾病，是一种常见的卫生害虫，喜欢在人或畜的粪尿、痰、呕吐物以及尸体等处爬行觅食，容易附着病原体。",
      keyword: '苍蝇,卫生害虫,苍蝇的危害'
    },
    '8': {
      title: "蚊子_消灭蚊子_为什么蚊子总是咬我一个人-Byepest虫虫拜拜官网",
      description: "蚊子是一种具有刺吸式口器的细小昆虫。一般雄蚊以植物汁液为食，唯雌蚊吸取血液。蚊子的唾液会使宿主出现皮疹等症状，且是许多种疾病的传播媒介。",
      keyword: '蚊子,伊蚊,花脚蚊,蚊子的危害'
    },
    '9': {
      title: "臭虫_灭除臭虫_有臭虫怎么办-Byepest虫虫拜拜官网",
      description: "成年臭虫呈褐红色，扁平带椭圆形，少数臭虫有翅膀且会飞。臭虫以人类血液为食，它的首选栖息地是床板，尤其是病床或其他公共场所的床。臭虫抗药性强，根除十分困难。",
      keyword: '臭虫,床虱,臭虫的危害'
    },
    Term: {
      title: "服务协议-Byepest虫虫拜拜官网",
      description: "Byepest虫虫拜拜所有上门除虫服务均有相应的服务协议，均具有法律效应。我们将依此确保服务品质，保障双方的权益。",
      keyword: '上门除虫,除虫服务,除虫公司'
    },
    Privacy: {
      title: "个人信息保护政策-Byepest虫虫拜拜官网",
      description: "Byepest虫虫拜拜在为用户提供专业除虫服务的同时，将严格按照安蔚优标准妥善保护用户的个人信息安全。",
      keyword: '专业上门除虫服务,除虫公司'
    },
    // Enterprise: {
    //   title: "办公室除蟑螂灭老鼠_商业场所除虫-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜官网为您提供商业除虫服务，如办公室除蟑螂、灭老鼠等服务。更多商业除虫服务请关注虫虫拜拜官网。",
    //   keyword: '办公室除蟑螂灭老鼠,商业场所除虫'
    // },
    // Price: {
    //   title: "办公室除蟑螂灭老鼠价格_商业场所除虫收费-拜耳虫虫拜拜官网",
    //   description: "虫虫拜拜官网为您提供商业除虫服务并助您了解商业除虫价格，如办公室除蟑螂、灭老鼠等服务。更多商业除虫服务请关注虫虫拜拜官网。",
    //   keyword: '办公室除蟑螂灭老鼠价格,商业场所除虫收费'
    // },
}

function metaSet(routerObj) {
  let _obj = routerObj.name
  switch (routerObj.name) {
    case "PestWikiDetail":
      _obj = routerObj.params.id
      break
    case "Service":
      _obj = routerObj.params.serviceId
      break
    case "Category":
      _obj = routerObj.params.id
      break
  }

  const metaName = $meta[_obj] ? _obj : 'Home'
  const _meta = {
    title: $meta[metaName].title,
    meta: [
      { name: 'description', content: $meta[metaName].description },
      { name: 'Keywords', content: $meta[metaName].keyword }
    ]
  }
  return _meta
}
export default { metaSet }


// WEBPACK FOOTER //
// ./src/controller/metaInfo.js